import React from 'react'
import Navbar from '../inc/Navbar'
import about from "../images/Sampang homestay.20.png";
import ScrollToTop from "react-scroll-to-top";
function Aboutus() {
  return (
    <div>
        <Navbar/>
         <br />
      <br />
      <br />
      <br />
             <ScrollToTop smooth top="100" color="darkgoldenrod" />

  <div className='album py-2'>
        <div className='container'>
          <div className="row">


            <div className="col-md-6 mt-3">
              <img src={about} className="card-img-top" alt="about_Sampangshomestay" />

            </div>
  <div className="col-md-6 mt-3">
              <h1 style={{color:"#085b22"}}><b>Sampang's Homestay – Stay, Relax & Explore 🌿🏡</b></h1>
              <h6>Welcome to Sampang's Homestay, a peaceful and comfortable stay surrounded by the beauty of nature. Whether you are planning a family vacation, romantic getaway, group trip or a relaxing holiday, Sampang's Homestay is the perfect place to stay and enjoy a memorable experience.</h6>
              <h5><b>✨ Why Choose Sampang's Homestay?</b></h5>
              <p className='mb-2'>* Comfortable & spacious rooms

</p>
<p className='mb-2'>* Balcony view from all rooms
</p>
<p className='mb-2'>* Geyser & hot water available all the time
</p>
<p className='mb-2'>* Peaceful natural surroundings</p>
<p className='mb-2'>* Perfect for families, couples & groups
</p>
<p className='mb-2'>* Relaxing atmosphere away from the busy city life
</p>
<p><small>Enjoy beautiful views, fresh air, comfortable rooms and a peaceful stay at Sampang's Homestay.</small></p>

            </div>
            </div>
            </div>
            </div>
            <br/>


    </div>
  )
}

export default Aboutus